import { EnvironmentOutlined, HomeOutlined } from "@ant-design/icons";
import { Button, Drawer, Select, Space, Tooltip } from "antd";
import useGetFiliales from "hooks/useGetFiliales";
import { useState } from "react";
import { filterOption, lowerAndCapitalizeFirstLetter } from "utils";
import useCambiarFilial from "./useCambiarFilial";

const CambiarFilial = ({ usuario, buttonStyles }) => {
  const { filialesOptions } = useGetFiliales({ origen: "auth" });
  const [open, setOpen] = useState(false);
  const { handleCambiarFilial, loading } = useCambiarFilial();

  const onChange = (filialId) => {
    handleCambiarFilial(usuario?.id, filialId);
  };

  return (
    <div>
      {(usuario.super || usuario.cambia_filial) ? (
        <Tooltip title="Cambiar filial" mouseLeaveDelay={0}>
          <Button
            type="text"
            style={{
              color: buttonStyles?.color,
              height: buttonStyles?.height,
            }}
            icon={<HomeOutlined />}
            onClick={() => setOpen(true)}
          >
            {lowerAndCapitalizeFirstLetter(usuario?.filial?.nombre)}
          </Button>
        </Tooltip>
        ) : (
          <Space
            style={{
              color: buttonStyles?.color,
              padding: '0 15px',
            }}
          >
            <EnvironmentOutlined />
            {lowerAndCapitalizeFirstLetter(usuario?.filial?.nombre)}
          </Space>
        )
      }
      {open &&
        <Drawer
          title="Cambiar filial"
          onClose={() => setOpen(false)}
          open={open}
          placement="top"
          height={140}
        >
          <Select
            value={usuario?.filiales_id}
            options={filialesOptions}
            placeholder="Seleccionar"
            filterOption={filterOption}
            onChange={onChange}
            showSearch
            style={{ width: '100%' }}
            loading={loading}
          />
        </Drawer>
      }
    </div>
  );
};


export default CambiarFilial;